<template>
  <div class="modal-message">
    <div class="card" v-loading="loading" element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">Privately Share</h4>
      </div>
      <div class="card-content">
        <div v-if="wallet" class="">
          Please enter the email address of the individual you'd like to share your verificaiton wallet with.<br/>
          Once they have registered with Qualification Check they will be able to access your verifications via their verification history section.
        </div>
        <div v-else class="">
          Please enter the email address of the individual you'd like to share this verificaiton with.<br/>
          Once they have registered with Qualification Check they will be able to access this verification via their verification history section.
        </div>
        <br/>
        <dynamic-input label="email" :labelVisible="false" :inline="false" name="value" :validations="{required: true, email:true}" v-model="value" :controlSize="12" />
        <span class="help-block">{{charsLeft}} character(s) left.</span>
      </div>
      <div class="card-footer">
          <button @click="$modal.close()" class="btn">{{closeText}}</button>
          <button v-if="actionText" @click="loading = true; action(value)" v-bind:disabled="$validator.errors.any()" v-bind:class="{'btn-disabled': $validator.errors.any()}" class="btn btn-fill btn-wd pull-right">{{actionText}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  
  export default {
    name: 'modal-message',
    components: {
      DynamicInput
    },
    data () {
      return {
        loading: false,
        value: null
      }
    },
    props: {
      wallet: {type: Boolean, default: false},
      maxChars: {type: Number, default: 500},
      closeText: {type: String, default: "Cancel"},
      actionText: {type: String, default: "Share"},
      action: {type: Function}
    },
    computed: {
      charsLeft() {
        return this.maxChars - (this.value != null ? this.value.length : 0)
      }
    }
  }
</script>

<style>
  .modal-message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>